import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import online1 from "../../Assets/online2.svg";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">We Are</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "50px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={online1} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <br/>
        <br/>
        <h1 className="project-heading">
          Our <strong className="purple">Sectors</strong>
        </h1>
        <br/>

        <Techstack />
        <br/>
        <br/>
        <br/>
        <br/>

        <h1 className="project-heading">
          <strong className="purple">Platforms</strong> We Use
        </h1>
        <br/>
        <Toolstack />
        <br/>
        <br/>
        <br/>

        {/* <Github /> */}
      </Container>
    </Container>
  );
}

export default About;
